import { Config } from '../config/env.config';
import { StatusModel } from './status.model';
import { SortModel } from './sort.model';

export class SearchModel {
  searchValue: string = ''; // The user entered search string
  id: number|string;
  resultValue: string = '';
  filters: Array<any> = [];
  status: string = 'all'; // The current status we are filtering by
  statusModel: StatusModel; // The current status we are filtering by
  sorting: string = '';
  sortModel: SortModel;
  route: string = ''; // The current route
  filter: Array<any> = [];
  selectAll: string = 'on-page'; // When selecting all, either "in-list" or "on-page"
  size: number = 1000;
  total: number = 0;
  currentPage: number = 1; // Current Page Number
  lastPage: number = 1; // Last Page Number
  itemsPerPage: number = Config.DEFAULT_ITEMS_PER_PAGE; // The number of items to show per page
  allSelected: boolean = false; // The user has choosen to select all items in for the given search
  searchId: number; // partsImportId or partsExportId
  columns: Array<string> = [];
  productId: number;
}
